import type { Observable } from 'rxjs';

import type { JobSchedulerData, OfferStatus } from '@recruitee/offers-types';

export type StatusChangeParam = {
  id: number;
  status: OfferStatus;
  jobScheduler?: JobSchedulerData;
};

export abstract class StatusChangeFacade {
  public abstract setPublished(param: StatusChangeParam): void;
  public abstract setInternal(param: StatusChangeParam): void;
  public abstract setClosed(param: StatusChangeParam): void;
  public abstract confirmClose$(param: StatusChangeParam): Observable<boolean>;
  public abstract setPublishedNow$?(param?: StatusChangeParam): Observable<boolean>;
}
